(function () {
  function initDragScroll(list) {
    if (list.dataset.ibscentSeoReady === 'true') return;
    list.dataset.ibscentSeoReady = 'true';

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;
    var pointerId = null;

    function onPointerDown(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      isDown = true;
      moved = false;
      startX = event.pageX;
      scrollLeft = list.scrollLeft;
      pointerId = event.pointerId;
    }

    function onPointerMove(event) {
      if (!isDown) return;
      var walk = event.pageX - startX;
      if (!moved && Math.abs(walk) > 5) {
        moved = true;
        list.classList.add('is-dragging');
        try { list.setPointerCapture(pointerId); } catch (_) {}
      }
      if (moved) {
        list.scrollLeft = scrollLeft - walk;
        event.preventDefault();
      }
    }

    function onPointerUp() {
      if (!isDown) return;
      isDown = false;
      list.classList.remove('is-dragging');
      if (pointerId !== null) {
        try { list.releasePointerCapture(pointerId); } catch (_) {}
        pointerId = null;
      }
    }

    function onClick(event) {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }

    list.addEventListener('pointerdown', onPointerDown);
    list.addEventListener('pointermove', onPointerMove);
    list.addEventListener('pointerup', onPointerUp);
    list.addEventListener('pointerleave', onPointerUp);
    list.addEventListener('pointercancel', onPointerUp);
    list.addEventListener('click', onClick);
    list.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
  }

  function bootstrap() {
    document.querySelectorAll('[data-ibscent-seo-list]').forEach(initDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ibscent-seo-list]').forEach(initDragScroll);
  });
})();
